import classNames from 'classnames';
import React from 'react';
import Badge from '../../components/Badge';
import CopyLinkButton from '../../components/CopyLinkButton';
import * as styles from './VersionChangeCard.module.scss';
import formatHistoryDate from './formatHistoryDate';

interface RootProps {
  children: React.ReactNode;
  focused: boolean;
  onClick?: React.MouseEventHandler;
}

const Root = ({ children, focused, onClick }: RootProps) => {
  return (
    <div
      className={classNames(styles.root, {
        [styles.focused]: focused,
      })}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

interface ContentContainerProps {
  children: React.ReactNode;
}

const ContentContainer = ({ children }: ContentContainerProps) => {
  return <div className={styles.contentContainer}>{children}</div>;
};

interface NewBadgeContainerProps {
  children: React.ReactNode;
  showBadge: boolean;
}

const NewBadgeContainer = ({ children, showBadge }: NewBadgeContainerProps) => {
  return (
    <div className={styles.newBadgeContainer}>
      <div>{children}</div>
      {showBadge && (
        <Badge className={styles.badge} color="green">
          new
        </Badge>
      )}
    </div>
  );
};

interface ContentProps {
  name: string;
  insertedAt: Date;
}

const Content = ({ name, insertedAt }: ContentProps) => {
  return (
    <div className={styles.content}>
      <div className={styles.authorName}>{name}</div>
      <div className={styles.date}>{formatHistoryDate(insertedAt)}</div>
    </div>
  );
};

interface CompactAvatarContainerProps {
  children: React.ReactNode;
}

const CompactAvatarContainer = ({ children }: CompactAvatarContainerProps) => (
  <div className={styles.compactAvatarContainer}>{children}</div>
);

interface VersionChangeCardCopyLinkButtonProps {
  onCopyLink: () => void;
  children: React.ReactNode;
}

const VersionChangeCardCopyLinkButton = ({
  children,
  onCopyLink,
}: VersionChangeCardCopyLinkButtonProps) => {
  return (
    <CopyLinkButton onCopyLink={onCopyLink} className={styles.copyLinkButton}>
      {children}
    </CopyLinkButton>
  );
};

export default {
  Root,
  NewBadgeContainer,
  Content,
  ContentContainer,
  CompactAvatarContainer,
  CopyLinkButton: VersionChangeCardCopyLinkButton,
};
